export const GTM_ID = 'GTM-5LDWQSZ';
export const CONSENT_KEY = 'nb_consent_analytics';

export const hasDnt = () => {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
  return (
    navigator.doNotTrack === '1' ||
    // @ts-expect-error - msDoNotTrack is legacy
    navigator.msDoNotTrack === '1' ||
    // @ts-expect-error - window.doNotTrack is legacy
    window.doNotTrack === '1'
  );
};

export const hasConsent = () => {
  if (typeof window === 'undefined') return false;
  const explicit = window.__nbConsent?.analytics === true;
  const stored = window.localStorage?.getItem(CONSENT_KEY) === 'true';
  return explicit || stored;
};

export const loadGtm = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (hasDnt() || !hasConsent()) return;
  if (window.__nbGtmLoaded) return;
  window.__nbGtmLoaded = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const f = document.getElementsByTagName('script')[0];
  const j = document.createElement('script');
  const l = 'dataLayer';
  const dl = l !== 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = '/metrics/?id=' + GTM_ID + dl;
  f.parentNode?.insertBefore(j, f);
};
